import { isRejected, ListenerMiddlewareInstance } from "@reduxjs/toolkit";

import { language } from "@chef/constants";

import { billingApi, showNotification } from "../features";

const intl = (
  {
    no: {
      BASKET_UPDATE_FAILED:
        "Noe gikk galt ved oppdatering av dine abonnerte produkter",
    },

    se: {
      BASKET_UPDATE_FAILED:
        "Något gick fel vid uppdatering av dina prenumererade produkter",
    },

    dk: {
      BASKET_UPDATE_FAILED:
        "Noget gik galt ved opdatering af dine abonnerede produkter",
    },
  } as const
)[language];

export default (listener: ListenerMiddlewareInstance) => {
  listener.startListening({
    matcher: billingApi.endpoints.updateAgreementBasketProducts.matchRejected,
    effect: async (action) => {
      if (isRejected(action)) {
        showNotification({
          type: "error",
          message: intl.BASKET_UPDATE_FAILED,
        });
      }
    },
  });
};
